module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"privacy":"Datenschutz","noInfo":"Bis jetzt keine Informationen."},"en":{"privacy":"Privacy Policy","noInfo":"No information yet."}}')
  delete Component.options._Ctor
}
